import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'polished';
var StyledGlobalStyle = createGlobalStyle(["", " ", " ", " ", " ", " *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}"], normalizeStyle, borderBox, fontImpact, fontAccent, fontSourceSansPro);

function borderBox(props) {
  return props.borderBox && css(["*,*:before,*:after{box-sizing:border-box;}"]);
}

function normalizeStyle(props) {
  return props.normalize && normalize();
}

function fontImpact(props) {
  if (typeof window === 'undefined' || !props.fontImpact) {
    return;
  }

  var NABImpact = require('./fonts/NABImpact.woff');

  return css(["@font-face{font-family:'NABImpact';src:url(", ") format('woff');font-weight:normal;font-style:normal;font-display:auto;}"], NABImpact);
}

function fontAccent(props) {
  if (typeof window === 'undefined' || !props.fontAccent) {
    return;
  }

  var NABScript = require('./fonts/NABScript.woff');

  return css(["@font-face{font-family:'NABScript';src:url(", ") format('woff');font-weight:normal;font-style:normal;font-display:auto;}"], NABScript);
}

function fontSourceSansPro(props) {
  if (typeof window === 'undefined' || !props.fontSourceSansPro) {
    return;
  }

  var SourceSansProLight = require('./fonts/SourceSans-Light.woff');

  var SourceSansProRegular = require('./fonts/SourceSans-Regular.woff');

  var SourceSansProBold = require('./fonts/SourceSans-Bold.woff');

  var SourceSansProSemibold = require('./fonts/SourceSans-Semibold.woff');

  return css(["@font-face{font-family:'SourceSansPro';font-weight:300;font-style:normal;font-display:auto;src:url(", ") format('woff');}@font-face{font-family:'SourceSansPro';font-weight:400;font-style:normal;font-display:auto;src:url(", ") format('woff');}@font-face{font-family:'SourceSansPro';font-weight:600;font-style:normal;font-display:auto;src:url(", ") format('woff');}@font-face{font-family:'SourceSansPro';font-weight:700;font-style:normal;font-display:auto;src:url(", ") format('woff');}"], SourceSansProLight, SourceSansProRegular, SourceSansProSemibold, SourceSansProBold);
}

export default StyledGlobalStyle;